module.exports = __webpack_public_path__ + "img/bookingSuccess.566f2292.png";